export default "__VITE_ASSET__BuFuJrTX__";